export const FILE_CLASSIFICATION = {
    jpg: 'image/jpg',
    jpeg: 'image/jpeg',
    png: 'image/png',
    gif: 'image/gif',
    avif: 'image/avif',
    jfif: 'image/jfif',
    mp4: 'video/mp4',
    avi: 'video/avi',
    mov: 'video/mov',
    wmv: 'video/wmv',
    mkv: 'video/mkv',
    webm: 'video/webm',
    webp: 'video/webp',
    csv: 'text/csv',
    text: 'text/plain',
    pdf: 'application/pdf',
    doc: 'application/doc',
    docx: 'application/docx',
    pptx: 'application/pptx',
    xls: 'application/xls',
    xlsx: 'application/xlsx',
    json: 'application/json',
    odt: 'application/odt',
    ods: 'application/ods',
    odp: 'application/odp',
}

export const FILE_CLASSIFICATION_REVERSE = {
    'image/jpg': 'jpg',
    'image/jpeg': 'jpeg',
    'image/png': 'png',
    'image/gif': 'gif',
    'image/avif': 'avif',
    'image/jfif': 'jfif',
    'image/webp': 'webp',
    'video/mp4': 'mp4',
    'video/avi': 'avi',
    'video/mov': 'mov',
    'video/wmv': 'wmv',
    'video/mkv': 'mkv',
    'video/webm': 'webm',
    'video/webp': 'webp',
    'text/csv': 'csv',
    'text/plain': 'text',
    'application/pdf': 'pdf',
    'application/doc': 'doc',
    'application/docx': 'docx',
    'application/rtf': 'rtf',
    'application/vnd.oasis.opendocument.text': 'odt',
    'application/vnd.oasis.opendocument.spreadsheet': 'ods',
    'application/vnd.oasis.opendocument.presentation': 'odp',
    'application/vnd.ms-excel': 'xls',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.template': 'dotx',
    'application/vnd.ms-word.document.macroEnabled.12': 'docm',
    'application/vnd.ms-excel.sheet.macroEnabled.12': 'xlsm',
    'application/vnd.ms-powerpoint': 'ppt',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'pptx',
    'application/vnd.ms-powerpoint.presentation.macroEnabled.12': 'pptm',
    'application/epub+zip': 'epub',
    'application/vnd.apple.pages': 'pages',
    'application/vnd.google-apps.document': 'gdoc',
    'application/pptx': 'pptx',
    'application/xls': 'xls',
    'application/xlsx': 'xlsx',
    'application/json': 'json',
    'application/odt': 'odt',
    'application/ods': 'ods',
    'application/odp': 'odp',
}